import { deepMerge } from '../utils/objects';
import { substitute } from '../utils/strings';
import { getLocale } from '../locale';
var options = {
  skipUndefined: true
};
export var requiredMessage = function requiredMessage(props) {
  var type = props.type === 'array' ? 'array' : 'string';
  return substitute(getLocale("rules.required.".concat(type)), props);
};
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      message = _ref.message,
      tip = _ref.tip;

  return function (msg) {
    return deepMerge({
      required: true,
      message: requiredMessage
    }, deepMerge({
      message: message,
      tip: tip
    }, {
      message: msg
    }, options), options);
  };
});